<template>
  <div class="response_table">
    <table style="font-size: 12px">
      <thead :class="{show_th : add_padd}">
        <tr>
          <th v-for="(header, key) in headers" :key="key" @click="header.sort ? change_filter(key) : ''"
              :class="{ 'selected': filter_type === key, pointer: header.sort }" :style="'width:' + width[key] + '%;'">
            {{ translate(header.title) }}
            <i v-if="header.sort" class="mdi mdi-arrow-down"
              :class="{ 'reverse': filter_asc === 'asc' && filter_type === key }"></i>
          </th>
        </tr>
      </thead>
      <tbody class="text_table_field" ref="table_tbody">
        <tr v-for="(item, data_key) in main_data" :key="data_key">
          <td v-for="(elem, elem_key) in item" :key="elem_key" :style="'width:' + width[elem_key] + '%;'"
            :data-label="translate(headers[elem_key].title)">
            <div v-if="elem.type === 'json'" class="copy_json">
<!--              <span @click="copy_to_clipboard(elem.value)"> Copy </span>-->
              <span @click="openModalJson(elem.value)">View</span>
            </div>
            <div v-if="elem.type === 'ini'" class="copy_json">
              <span @click="openModalIni(elem)">View</span>
            </div>
            <div v-else-if="elem.type === 'link'">
              <router-link :to="check_item(elem_key, elem)" class="link">
                {{ elem.value }}
              </router-link>
            </div>
            <div v-else-if="elem.type === 'pre'">
              <pre class="pre">
                <span>{{ elem.value }}</span>
              </pre>
            </div>
            <span v-else>{{ check_item(elem_key, elem) }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import ModalJson from './ModalJson'
import ModalIni from './ModalIni'

export default {
  name: 'Table',
  props: ['data', 'headers', 'params'],
  data() {
    return {
      show: false,
      temp: '',
      date: [],
      filter_type: 0,
      filter_asc: 'asc',
      width: {},
      add_padd: false
    }
  },
  computed: {
    main_data() {
      let list = []
      for (let item of this.data) {
        let row = []
        for (let item_key in item) {
          row.push({
            value: item[item_key],
            type: this.headers[item_key].type
          })
        }
        list.push(row)
      }
      
      list.sort(this.compareNumbers)

      for (let item of list) {
        for (let item_key in item) {
          if (item[item_key].type === 'datetime') {
            let options = {
              hour12: false,
              hour: '2-digit',
              minute: '2-digit',
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
              timeZone: this.parameters.timezone
            }
            item[item_key].value = this.get_date(item[item_key].value, options)
          }else if (item[item_key].type === 'datetime_with_second') {
            let options = {
              hour12: false,
              second: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
              timeZone: this.parameters.timezone
            }
            item[item_key].value = this.get_date(item[item_key].value, options)
          }
        }
      }

      return list
    },
    parameters() {
      if (this.params) {
        return this.params
      }
      return {}
    }
  },

  created() {
    this.check_width()
    this.check_default_sort()
  },

  mounted(){
    let trs = this.$refs.table_tbody.querySelectorAll('tr')
    let sum = 0
    for (let tr of trs) {
      sum += tr.offsetHeight
    }
    if (sum > this.$refs.table_tbody.offsetHeight){
      this.add_padd = true
    }
  },

  methods: {
    check_default_sort() {
      for (let index in this.headers) {
        if (this.headers[index].default_sort) {
          this.filter_type = index
          this.filter_asc = this.headers[index].default_sort
        }
      }
    },
    openModalJson(val) {
      var t = this.$createElement(ModalJson, { props: { data: val }, on: { close: () => { this.$modal.hide('modal_json') } } })
      let temp = { render() { return t } }
      this.$modal.show(temp, {}, { height: 'auto', adaptive: true, clickToClose: true, scrollable: true, name: 'modal_json' })
    },
    openModalIni(val) {
      if(this.$route.name === 'device_section'){
        var t = this.$createElement(ModalIni, {
          props: { data: val },
          on: {
            close: () => { this.$modal.hide('modal_ini') },
            update: () => { this.$emit('update') }
          }
        })
        let temp = { render() { return t } }
        this.$modal.show(temp, {}, { height: 'auto', adaptive: true, clickToClose: true, scrollable: true, name: 'modal_ini' })
      }
    },
    check_item(key, item) {
      if (typeof (item.value) == "undefined" && item.value === null) {
        return ''
      }
      if (this.headers[key].type === 'link') {
        let template = this.headers[key].template.replace('{data}', item.value)
        return {path: template}
      }
      return item.value
    },
    check_width() {
      let length = {}
      let sum = 0
      for (let item of this.data) {
        for (let j in item) {
          if (length[j]) {
            length[j] += String(item[j]).length
          } else {
            length[j] = String(item[j]).length
          }

          if (item === this.data[this.data.length - 1]) {
            sum += length[j] / this.data.length
          }
        }
      }

      for (let key in length) {
        let item = Math.round((length[key] / this.data.length * 100) / sum)
        this.width[key] = item < 15 ? 15 : item > 70 ? 40 : item
      }
    },
    compareNumbers(a, b) {
      if (typeof (a[this.filter_type].value) == 'string') {
        if (this.filter_asc === 'asc') {
          return a[this.filter_type].value < b[this.filter_type].value ? 1 : -1;
        } else {
          return a[this.filter_type].value > b[this.filter_type].value ? 1 : -1;
        }
      } else if (typeof (a[this.filter_type].value) == 'number') {
        if (this.filter_asc === 'asc') {
          return a[this.filter_type].value - b[this.filter_type].value
        } else {
          return b[this.filter_type].value - a[this.filter_type].value
        }
      }
    },

    change_filter(type) {
      if (this.filter_type === type) {
        if (this.filter_asc === 'asc') {
          this.filter_asc = 'desc'
        } else {
          this.filter_asc = 'asc'
        }
      } else {
        this.filter_type = type
      }
    },
  },
}

</script>
<style lang='scss'>
.text_table {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;

  .response_table {
    padding: 5px 0;

    table {
      thead {
        tr{
          padding: 0;
        }
        &.show_th{
          tr{
            border-collapse: separate;
            padding-right: 10px;
          }
        }
      }

      th {
        overflow: hidden;
        i {
          opacity: 0;
          width: 0;
          display: inline-block;
        }

        &.selected {
          color: #000;

          i {
            opacity: 1;
            width: auto;
          }
        }
      }
    }
  }

  &_field {
    height: 100%;
    width: 100%;
    overflow: scroll;

    &::-webkit-scrollbar {
      width: 10px;
    }

    .copy_json {
      span {
        cursor: pointer;
      }
    }

    pre.pre {
      margin: 0;
      padding: 0;
      width: 100%;
      border: none;
      background-color: inherit;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}

.mdi-arrow-down {
  transform: rotate(0);
  transition: 0.2s;

  &.reverse::before {
    transform: rotate(180deg);
  }
}
</style>
